import React, { useState } from 'react';
import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { LEGAL } from '../../config/legal';
import LegalModal from '../legal/LegalModal';
import LegalPolicyLinks from '../legal/LegalPolicyLinks';
import { LegalDocType } from '../legal/legalContent';

const DashboardFooter: React.FC = () => {
  const [legalDoc, setLegalDoc] = useState<LegalDocType | null>(null);
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const muted = useColorModeValue('gray.500', 'gray.400');
  const hover = useColorModeValue('gray.700', 'gray.200');
  const bg = useColorModeValue('whiteAlpha.600', 'blackAlpha.300');

  return (
    <>
      <Box
        w={"100%"}
        as="footer"
        mt={8}
        py={6}
        borderTop="1px solid"
        borderColor={borderColor}
        bg={bg}
        borderRadius="lg"
        px={{ base: 2, md: 4, lg: 10 }}
      >
        <Flex
          direction={{ base: 'column', md: 'row' }}
          justify="space-between"
          align={{ base: 'flex-start', md: 'center' }}
          gap={4}
        >
          <Text fontSize="sm" color={muted}>
            © {new Date().getFullYear()} {LEGAL.productName}. All rights reserved.
          </Text>
          <LegalPolicyLinks onOpen={setLegalDoc} color={muted} hoverColor={hover} />
        </Flex>
      </Box>

      <LegalModal
        doc={legalDoc}
        isOpen={legalDoc !== null}
        onClose={() => setLegalDoc(null)}
        onNavigate={setLegalDoc}
      />
    </>
  );
};

export default DashboardFooter;
